const AlertIcon = () => (
    <div
        className="w-11 h-11 rounded-[30%] grid place-items-center shrink-0"
        style={{
            background: 'linear-gradient(135deg, #ff6262, #f04e3a)',
            boxShadow:
                '0 0 22px -2px rgba(255,98,98,0.7), inset 0 1px 0 rgba(255,255,255,0.35)',
        }}
        aria-label="Error"
    >
        <svg
            viewBox="0 0 24 24"
            className="w-6 h-6 stroke-white fill-none [stroke-width:2.8] [stroke-linecap:round] [stroke-linejoin:round]"
        >
            <path d="M12 7v6M12 16.5v.5" />
            <circle cx="12" cy="12" r="9.5" />
        </svg>
    </div>
);

export default AlertIcon;
